__turbopack_context__.v({
  "discountContainer": "SelectedPlanBlock-module-scss-module__9N2AGG__discountContainer",
  "discountLabel": "SelectedPlanBlock-module-scss-module__9N2AGG__discountLabel",
  "discountWrapper": "SelectedPlanBlock-module-scss-module__9N2AGG__discountWrapper",
  "planDetails": "SelectedPlanBlock-module-scss-module__9N2AGG__planDetails",
  "planDetailsPrice": "SelectedPlanBlock-module-scss-module__9N2AGG__planDetailsPrice",
  "planLabels": "SelectedPlanBlock-module-scss-module__9N2AGG__planLabels",
  "taxLine": "SelectedPlanBlock-module-scss-module__9N2AGG__taxLine",
});
